import { useWeb3React } from '@web3-react/core';
import { useContext } from 'react';
import useSWR from 'swr';
import appContext from '../../../context/app/appContext';

const useTotalClaimedYield = () => {
    const { account } = useWeb3React();

    const { sdk } = useContext(appContext);

    const { data, error } = useSWR(
        sdk && account ? ['totalClaimedYield', account] : null,
        (_, userAddress) => sdk!.spools.getTotalUserYieldRealized(userAddress!)
    );

    return {
        totalClaimedYield: data,
        isLoading: !error && !data,
        error,
    };
};

export default useTotalClaimedYield;
